import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

const HealofyGallery = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <section className="pt-10 pb-20">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl">
        <div className="flex flex-col gap-1 mb-8">
            <h2 className="text-3xl font-serif text-neutral-900">Healofy</h2>
            <span className="text-lg font-light text-accent">2019 - 2021</span>
        </div>

        <motion.div 
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="w-full"
        >
          {/* Card 1: Vernacular Growth - Single Card with Edge-to-Edge Image & Padding */}
          <motion.div 
            variants={item} 
            whileTap={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
            className="bg-white rounded-[2rem] relative overflow-hidden group hover:bg-pastel-hover transition-colors border border-neutral-100 flex flex-col cursor-pointer h-[500px]"
            onClick={() => window.open('https://docs.google.com/presentation/d/1w_goKzq1Ag01Eu9_I1bqFNO6TH5eej7tj38Qp2UC34s/edit?usp=sharing', '_blank')}
          >
             <div className="p-10 pb-0 flex justify-between items-start z-10 relative">
                <h3 className="text-2xl font-bold text-neutral-900 max-w-lg">India's Largest Vernacular Parenting App</h3>
                <div className="w-12 h-12 bg-pastel-cream rounded-full flex items-center justify-center shadow-sm group-hover:bg-accent group-hover:text-white transition-all border border-neutral-100 shrink-0">
                    <ArrowUpRight className="w-5 h-5" />
                </div>
             </div>

             {/* Full Width Image Container with Padding */}
             <div className="w-full flex-1 mt-6 relative z-0 px-10 pb-10">
                <div className="w-full h-full rounded-2xl overflow-hidden shadow-sm">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_design-clarity-3/artifacts/qit233ua_Cards.jpg" 
                    alt="Healofy App Interface" 
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  />
                </div>
             </div>
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default HealofyGallery;
